import React, { Component } from "react";

export default class Nav extends Component {
  render() {
    return (
      <div class="navbar bg-base-100 z-40">
        <div class="navbar-start">
          <div class="dropdown">
            <label tabindex="0" class="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </label>
            <ul
              tabindex="0"
              class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
            >
              <li>
                <a href="/About">About Us</a>
              </li>
              <li>
                <a href="/webdev">Website Development</a>
              </li>
              <li>
                <a href="/ai">AI Solutions</a>
              </li>
              <li>
                <a href="/marketing">Social Media Marketing</a>
              </li>
            </ul>
          </div>
          <a href="/" class="btn btn-ghost normal-case text-3xl">
            Imaginex
          </a>
        </div>
        <div class="navbar-center hidden lg:flex">
          <ul class="menu menu-horizontal p-0">
            <li>
              <a href="/About">About Us</a>
            </li>
            <li>
              <a href="/webdev">Website Development</a>
            </li>
            <li>
              <a href="/ai">AI Solutions</a>
            </li>
            <li>
              <a href="/marketing">Social Media Marketing</a>
            </li>
          </ul>
        </div>
        <div class="navbar-end gap-2">
                        <a href="mailto:theimaginexcompany@gmail.com" class="btn bg-[#618A3D] text-white font-bold py-2 px-4 hover:bg-[#75a64b] outline-none">Contact Us</a>
        </div>
      </div>
    );
  }
}
